import type { RouteLocationNormalized } from "vue-router";
import type { TypedRoute } from "../../.nuxt/typed-router/__router";

export default (to: RouteLocationNormalized | TypedRoute) =>
    to.matched.length === 0;
